module.exports = __webpack_public_path__ + "img/Park.1ce58d91.svg";